import { blue } from "@material-ui/core/colors";

const styles = (theme) => ({
  root: {
    top: "62px",
    left: "340px",
    border: "none",
    position: "fixed",
    width: "100%",
    boxShadow: "none",
    paddingTop: "16px",
    backgroundColor: "#eeeeee",
    zIndex: 20,
  },
  filterBarContainer: {
    height: 45,
    padding: "0 20px",
  },

  selectedFilterContainer: {
    paddingTop: 7,
    cursor: "default",
    color: "#424242",
    display: "inline-block",
    fontSize: 12,
  },

  seperator: {
    fontWeight: "bold",
    paddingRight: 8,
  },
  navbarContainer: {
    paddingTop: 7,
    cursor: "default",
    color: "#fff",
    display: "inline-block",
  },
  navbarLink: {
    color: "#424242",
    textTransform: "uppercase",
    fontSize: 12,
    letterSpacing: 1,
    textDecoration: "none",
    padding: 5,
  },
  selectedFilterIcon: {
    display: "inline-block",
    verticalAlign: "middle",
    width: 20,
    cursor: "pointer",
  },
  removeFilterIcon: {
    cursor: "pointer",
    display: "inline-block",
    verticalAlign: "middle",
    width: 20,
    paddingLeft: 10,
  },
  selectedFilterName: {
    display: "inline-block",
    verticalAlign: "middle",
    margin: 0,
    paddingLeft: 5,
    textTransform: "uppercase",
    cursor: "pointer",
  },
  selectedFilterNameNoPointer: {
    display: "inline-block",
    verticalAlign: "middle",
    margin: 0,
    paddingLeft: 5,
    textTransform: "uppercase",
  },
  filterDialogPaper: {
    maxWidth: "800px !important",
    minWidth: "800px !important",
    width: 800,
  },
  filterDialogContentRoot: {},
  filterContentContainer: {
    height: 400,
    display: "flex",
    flexDirection: "row",
    // backgroundColor: '#aeaeae'
  },

  filterMenuContainer: {
    display: "inline-block",
    verticalAlign: "middle",
    margin: 0,
    paddingLeft: 5,
    paddingRight: 22,
    textTransform: "uppercase",
    cursor: "pointer",
    paddingBottom: 2,
  },
  filterMenuContainer_spaced: {
    verticalAlign: "middle",
    margin: 0,
    paddingLeft: 50,
    paddingRight: 22,
    textTransform: "uppercase",
    cursor: "pointer",
    paddingBottom: 2,
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  claimClickDisabled: {
    color: "lightgray",
    cursor: "initial",
  },
  laimClickActive: {
    color: "initial",
    cursor: "pointer",
  },

  claim_menu: {
    textTransform: "initial",
    padding: "17px 17px",
    cursor: "initial",
    maxWidth: 400,
  },

  bulkAction: {
    display: "inline-block",
    verticalAlign: "middle",
    margin: 0,
    paddingLeft: 50,
    paddingRight: 22,
    textTransform: "uppercase",
    cursor: "pointer",
    paddingBottom: 2,
  },
  selectedBulkIcon: {
    display: "inline-block",
    verticalAlign: "middle",
    width: 20,
    cursor: "pointer",
    paddingRight: 0,
  },

  dataListRoot: {
    height: 240,
    marginTop: 10,
    overflowY: "scroll",
    border: "1px solid #eee",
    // marginBottom: 10
  },
  collectionPartnerListRoot: {
    margin: "0px 25px",
  },

  heading: {
    fontSize: 17,
    flexBasis: "66.66%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },

  imageContainer: {
    // width:100,
    // height:60,
    // display: 'flex',
    // flexWrap: 'wrap',
    // display:"inline-block",
    maxHeight: 100,
    maxWidth: 60,
    paddingLeft: 10,
  },
  gridList: {
    // width: 500,
    // height: 450,
  },
  gridListSelected: {
    backgroundColor: theme.palette.secondary.light,
    // width: 500,
    // height: 450,
  },

  switchSelect: {
    marginTop: 15,
  },

  switchLabel: {
    fontSize: 14,
    display: "block",
  },

  optionFormControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },

  selectAllContainer: {
    height: 30,
    display: "block",
  },
  selectAllText: {
    lineHeight: "35px",
    display: "inline-block",
  },
  selectAllBtn: {
    display: "inline-block",
    float: "right",
  },

  tagInput: {
    zIndex: 10,
    // height:150
  },
  totalBox: {
    padding: "2px 10px",
    fontSize: 12,
    paddingTop: 4,
    minWidth: 200,
    marginRight: 10,
    borderRadius: 9,
    backgroundColor: "#2680eb",
  },

  menu: {
    top: 40,
  },
  menuRoot: {
    padding: 0,
  },
  menuPaper: {
    // backgroundColor:"#333"
  },
  menuItem: {
    width: 250,
    padding: "15px 20px",
  },
  menuItemButton: {
    paddingBottom: 10,
    textAlign: "center",
    outline: "none",
    border: "none",
  },
  rightIcon: {
    marginRight: theme.spacing.unit,
  },
  primary: {
    fontWeight: "400",
  },
  secondary: {
    color: blue[600],
  },
  button: {
    textTransform: "initial",
    fontSize: 14,
    height: 40,
    color: "#2680eb",
    backgroundColor: "#fff",
    border: "1px solid #2680eb",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#2680eb",
      border: "1px solid transparent",
    },
  },
  addNewFilterButton: {
    margin: "0px 15px",
    color: "#2680eb",
    backgroundColor: "#fff",
    border: "1px solid #2680eb",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#2680eb",
      border: "1px solid transparent",
    },
  },
});

export default styles;
